module.exports = __webpack_public_path__ + "img/3.964339ac.jpg";